import React, { useState, useEffect } from 'react';
import { requester } from 'App';
import styles from './SettlementPage.module.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

function SettlementPage() {
    const [aboveThresholdStatistics, setAboveThresholdStatistics] = useState(null);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [loading, setLoading] = useState(true);
    
    // 월 변경 함수
    const changeMonth = (amount) => {
        const newDate = new Date(currentDate);
        newDate.setMonth(newDate.getMonth() + amount);
        setCurrentDate(newDate);
    };
    
    // 현재 표시 중인 년월 포맷팅 (YYYY-MM)
    const currentYearMonth = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;

    // 필터링된 데이터
    const filteredStats = aboveThresholdStatistics ? 
        aboveThresholdStatistics.filter(stat => stat.timePeriod === currentYearMonth) : 
        [];

    useEffect(() => {
        setLoading(true);
        
        let statisticsData = {
            endDate: "2025-12-31", 
            startDate: "2025-01-01",
            storeId: "4000",
            timeUnit: "month"
        };
        
        requester.getAllStatisticsAboveThreshold(statisticsData, (result) => {
            if (result.code === 0) {
                setAboveThresholdStatistics(result.data);
            }
            setLoading(false);
        });
    }, []);

    return (
        <div className={styles.container}>
            <h1 className={styles.pageTitle}>스토어별 월별 정산 예정금액</h1>
            
            <div className={styles.monthSelector}>
                <button 
                    className={styles.monthBtn} 
                    onClick={() => changeMonth(-1)}
                >
                    <FaChevronLeft />
                </button>
                <span className={styles.currentMonth}>
                    {currentDate.getFullYear()}년 {currentDate.getMonth() + 1}월
                </span>
                <button 
                    className={styles.monthBtn} 
                    onClick={() => changeMonth(1)}
                >
                    <FaChevronRight />
                </button>
            </div>
            
            <div className={styles.content}>
                {loading ? (
                    <div className={styles.loading}>데이터를 불러오는 중...</div>
                ) : (
                    filteredStats.length > 0 ? (
                        <div className={styles.settlementStats}>
                            <table className={styles.statsTable}>
                                <thead>
                                    <tr>
                                        <th>매장명</th>
                                        <th>기간</th>
                                        <th>총 매출</th>
                                        <th>공급가액</th>
                                        <th>예상 본사 수수료</th>
                                        <th>예상 점주 수령액</th>
                                        <th>비고</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredStats.map((stat, index) => (
                                        <tr key={index}>
                                            <td>{stat.storeName}</td>
                                            <td>{stat.timePeriod}</td>
                                            <td>{stat.totalSales.toLocaleString()}원</td>
                                            <td>{stat.totalSupplierCost.toLocaleString()}원</td>
                                            <td>{stat.totalHeadquartersCommission?.toLocaleString() || 0}원</td>
                                            <td className={stat.totalStoreOwnerAmount < 0 ? styles.negative : ''}>
                                                {stat.totalStoreOwnerAmount?.toLocaleString() || 0}원
                                            </td>
                                            <td>
                                                {/* 추가 데이터나 버튼 등을 표시할 수 있음 */}
                                                <button className={styles.detailBtn}>상세보기</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className={styles.noData}>해당 월의 데이터가 없습니다.</div>
                    )
                )}
            </div>
        </div>
    );
}

export default SettlementPage; 